<script>
import { v4 as uuidv4 } from 'uuid'

export default {
  props: {
    value: {
      type: Object,
      default: () => { }
    },
    steps: {
      type: Array,
      required: true
    }
  },
  data(vm) {
    return {
      isValidating: false,
      form: vm.value,
      currentStep: null,
      stepCounter: 0
    }
  },
  computed: {
    isFirstStep() {
      return this.stepCounter === 0
    },
    isLastStep() {
      return this.stepCounter === this.steps.length - 1
    }
  },
  watch: {
    stepCounter: {
      handler(val, old_val) {
        if (this.currentStep) this.currentStep.active = false
        this.currentStep = this.steps[val]
        if (!this.currentStep) return

        if (this.currentStep.skip) {
          if (old_val === undefined || old_val < val) {
            if (this.stepCounter < this.steps.length - 1) {
              this.stepCounter += 1
              return
            }
          } else if (old_val > val && this.stepCounter > 0) {
            this.stepCounter -= 1
            return
          }
        }

        this.currentStep.active = true
      },
      immediate: true
    },
    value: {
      handler(val) {
        const merged = { ...this.form, ...val }
        if (
          this.form.customer_account_id &&
          (val.customer_account_id === null ||
            val.customer_account_id === undefined ||
            val.customer_account_id === '')
        ) {
          merged.customer_account_id = this.form.customer_account_id
        }
        this.form = merged
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    reset() {
      this.stepCounter = 0
      if (this.currentStep) this.currentStep.active = false
      this.currentStep = this.steps[this.stepCounter]
      while (this.currentStep?.skip && this.stepCounter < this.steps.length - 1) {
        this.stepCounter += 1
        this.currentStep = this.steps[this.stepCounter]
      }
      if (this.currentStep) this.currentStep.active = true
    },
    mergeForm(data = {}) {
      const merged = { ...this.form }

      for (const [key, value] of Object.entries(data)) {
        if (
          key === 'customer_account_id' &&
          merged.customer_account_id &&
          (value === null || value === undefined || value === '')
        ) {
          continue
        }
        merged[key] = value
      }

      this.form = merged
      this.$emit('input', this.form)
    },
    validateStep() {
      const ref = this.$refs[`ref_${this.currentStep.id}`]
      const form = ref ? ref[0] : null
      if (form && typeof form.validate === 'function') {
        return form.validate()
      }
      return true
    },
    onStepBackHandler() {
      if (this.stepCounter <= 0) return
      let prev = this.stepCounter - 1
      while (prev > 0 && this.steps[prev]?.skip) {
        prev -= 1
      }
      if (this.steps[prev]?.skip) return
      this.stepCounter = prev
    },
    async onNextStepHandler() {
      this.isValidating = true
      const stepValid = await this.validateStep()

      this.isValidating = false
      if (stepValid) {
        if (this.stepCounter < this.steps.length - 1)
          this.stepCounter = this.stepCounter + 1
      }
    },
    onValidatedHandler(data) {
      this.mergeForm(data)
      if (this.isLastStep) this.$emit('complete')
    },
    onStepInputHandler(data) {
      this.mergeForm(data)
    },
    onCompleteHandler() {
      if (this.validateStep()) {
        //this.$emit("complete", { ...this.form });
      }
    }
  },
  created() {
    this.stepCounter = 0
    this.currentStep = this.steps[this.stepCounter]
    while (this.currentStep?.skip && this.stepCounter < this.steps.length - 1) {
      this.stepCounter += 1
      this.currentStep = this.steps[this.stepCounter]
    }
    if (this.currentStep) this.currentStep.active = true
  }
}
</script>

<template>
  <div role="tablist">
    <g-overlay :show="isValidating">
      <template v-for="step in steps">
        <b-card no-body class="mb-0" v-if="step.active" :key="step.id">
          <b-card-header header-tag="header" role="tab" class="pointer bg-transparent shadow-none">
            <h6 class="text-capitalize text-primary font-weight-light m-0 d-flex align-items-center">
              <i :class="step.icon" class="mr-2 font-size-18" v-if="step.icon" />{{ step.title }}
            </h6>
          </b-card-header>
          <b-card-body class="pt-1">
            <component :is="step.component" :title="step.title" :ref="`ref_${step.id}`"
              v-on:validated="onValidatedHandler" v-on:input="onStepInputHandler" :value="form" class="m-0" />
          </b-card-body>
        </b-card>
      </template>
      <slot name="buttons" :isLastStep="isLastStep" :isFirstStep="isFirstStep" :nextStep="onNextStepHandler"
        :previousStep="onStepBackHandler" :submit="onCompleteHandler" :validateStep="validateStep">
        <div class="d-flex justify-content-between align-items-center my-3">
          <b-btn variant="link" class="mr-2 d-flex align-items-center" v-on:click="onStepBackHandler"
            :disabled="isFirstStep">
            <i class="bx bx-left-arrow mr-2"></i>Back
          </b-btn>

          <b-btn variant="success" class="btn-label" v-on:click="onCompleteHandler" v-if="isLastStep">
            <i class="bx bx-cart label-icon"></i>
            Add To Cart
          </b-btn>
          <b-btn variant="primary" class="mr-2 d-flex align-items-center" v-on:click="onNextStepHandler" v-else>
            Next<i class="bx bx-right-arrow ml-2"></i>
          </b-btn>
        </div>
      </slot>
    </g-overlay>
  </div>
</template>
